import { gql } from 'apollo-angular';

export const GET_STATIONARY = gql`
  query stationories($search: String) {
    stationories(search: $search) {
      id
      stationoryName
      stationoryCode
      price
      stock
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const FETCH_STATIONARY_BY_ID = gql`
  query stationory($id: Int!) {
    stationory(id: $id) {
      id
      stationoryName
      stationoryCode
      price
      stock
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const GET_STATIONARY_CODE = gql`
  query {
    generateStationoryCode
  }
`;